import React, { PureComponent, PropTypes } from 'react';

import './styles.scss';

export class Modal extends PureComponent {
  render() {
    return (
      <div className='modal'>
        <div className="modal-background" />
        <div className="modal-content">
          <i className={this.props.icontype} aria-hidden="true" />
          <h3>{this.props.title}</h3>
          <p>{this.props.message}</p>
          <button
            className="blue"
            onClick={(event) => {
              event.preventDefault();
              this.props.onClick();
            }}
          >
            <p>OK</p>
          </button>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  icontype: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  onClick: PropTypes.func,
};


export default Modal;



// WEBPACK FOOTER //
// ./src/components/shared/modals/main.jsx